export default __webpack_public_path__ + "static/media/csv.4c52e2ad.svg";